import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/d4bce4b0-6b71-4201-b51c-c004861c34e8.png" 
              alt="ROLI SH.P.K. Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-lg font-medium tracking-wider transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              ROLI SH.P.K.
            </span>
          </div>
          <div className="flex gap-8">
            {['Home', 'About', 'Products', 'Features', 'Contact'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className={`text-sm font-medium transition-colors hover:opacity-80 cursor-pointer ${
                  scrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </nav>

      <Hero />
      <About />
      <Products />
      <Features />
      <Contact />
    </div>
  );
}